<script>
	import Axios from 'axios'
	import { mapGetters } from 'vuex'
	import AOS from 'aos'
	import 'aos/dist/aos.css'


	import _system from '../../../libs/system'
	
	export default 
	{
		name: 'bugReports',
		data(){
			return {
				loader: false
			}
		},
        computed: 
	    {
      ...mapGetters('session', ['isLoggedIn', 'getUser'])
		},
		created(){
			AOS.init(); 
		},
		mounted(){

		this.loader = true;

				!function(w,d,i,s){function l(){if(!d.getElementById(i)){var f=d.getElementsByTagName(s)[0],e=d.createElement(s);e.type="text/javascript",e.async=!0,e.src="https://canny.io/sdk.js",f.parentNode.insertBefore(e,f)}}if("function"!=typeof w.Canny){var c=function(){c.q.push(arguments)};c.q=[],w.Canny=c,"complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)}}(window,document,"canny-jssdk","script");

			_system.services.canny.createCannyToken((err, data) => {
				if(err) return alert('Something went wrong! Try again later!')
				Canny('render', {
					boardToken: 'e81902d8-c284-889c-42e2-d6c31d757ece',
					basePath: '/community/bug-reports', // See step 2
					ssoToken: data.cannyToken, // See step 3
						onLoadCallback: () => {
							this.loader = false
						}
				});
			});

		}
	}
</script>

<template>
<span>

<div class="ui secondary menu perhaps">
	<div style="color: #ffffff; font-weight: bold;" class="ui item">COMMUNITY BOARD</div>
	<router-link  class="ui item"  to="/community/feature-requests">
		<i class="bolt icon"></i> Feature Requests
	</router-link>
	<router-link  class="ui active item"  to="/community/bug-reports">
		<i class="bug icon"></i> Bugs
	</router-link>
</div>	
<div class="ui basic segment">
        <div v-if="loader" data-aos="zoom-in" style="height:100%;" class="ui grid centered middle aligned stackable">
            <div class="six wide computer sixteen wide mobile column">
                <div class="ui basic segment center aligned">
                <div style="padding:0; color: #333;" class="ui basic segment">
                </div>
                <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
                </div>
            </div>
        </div>
<!-- <div data-aos="zoom-in" class="ui basic segment center aligned">
  <div style="background: transparent;" class="ui huge loading button "></div>
</div>	 -->	
	<div data-canny /> 
</div>
</span>
</template>

<style>
.inverted.menu.perhaps{
	margin-top: -1rem !important; 
	margin-left: -1rem !important; 
	margin-right: -1rem !important; 
	background: #D46E62 !important;
	padding:10px;
}
.menu.perhaps .item {
	margin-left: 6.5px;
	min-height: 2.85714286em;
}

.menu.perhaps .active.item {
    color: #3960BD !important;
}
.menu.perhaps .item {
    color: #3960BD !important;
}
</style>




// WEBPACK FOOTER //
// src/components/dashboard/communityBoard/bugReports.vue